import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';

/**
 * Floating "+N" / "-N" that fades upward or downward, then disappears.
 * @param {{ delta: number, seq: number, className?: string }} props
 * — `seq` must increment on each new delta to re-trigger the animation.
 */
export default function RpDeltaFloat({ delta = 0, seq = 0, className = '' }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (delta !== 0 && seq > 0) {
      setVisible(true);
      const t = window.setTimeout(() => setVisible(false), 1800);
      return () => window.clearTimeout(t);
    }
    setVisible(false);
  }, [delta, seq]);

  const positive = delta > 0;

  return (
    <AnimatePresence mode="popLayout">
      {visible ? (
        <motion.span
          key={seq}
          initial={{ opacity: 1, y: 0, scale: 1.1 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: positive ? -28 : 20 }}
          transition={{ duration: 1.4, ease: 'easeOut' }}
          className={`pointer-events-none text-sm font-bold tabular-nums ${
            positive ? 'text-emerald-400' : 'text-red-400'
          } ${className}`}
        >
          {positive ? `+${delta}` : delta}
        </motion.span>
      ) : null}
    </AnimatePresence>
  );
}
